import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { useMemo } from 'react';

function useComputedWidth() {
  var widthBuffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var defaultWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return useMemo(function () {
    var _context;
    return typeof defaultWidth === 'number' ? "".concat(defaultWidth + widthBuffer, "px") : _concatInstanceProperty(_context = "calc(".concat(widthBuffer, "px + ")).call(_context, defaultWidth, ")");
  }, [widthBuffer, defaultWidth]);
}

export { useComputedWidth as default };
